<template>
    <!-- TODO css -->
    <modal @close="modals.giftInviteModal = false">
        <div v-if="screen === 'form'">
            <!-- Link Generation Form -->
            <h3 v-if="!details.invite_link">Create A New Invitation</h3>
            <form @submit.prevent class="large-form">
                
                <!-- Link Generation Starting Screen -->
                <div class="form-step step-start" v-if="step === 'start'">
                    <h4><b>Step 1:</b> Recipient Details</h4>
                    
                    
                    <div class="form-line" v-if="this.voucherBrand">
                        <div class="form-field" style="width: 70%">
                            <label>Voucher Brand</label>
                            <div class="form-static-field">{{ option.name }}</div>
                        </div>
                        <div class="form-field" v-if="item.type=='voucher'" style="width: 30%">
                            <label>Value (£) *</label>
                            <select v-if="voucherDenominations.length" v-model="item.voucher_value">
                                <option v-for="val in voucherDenominations" :value="parseFloat(val)">{{ val | toCurrency }}</option>
                            </select>
                            <input type="number" v-else v-model="item.voucher_value" :min="voucherLimits.lower" :max="voucherLimits.upper" :step="voucherLimits.minor_unit" >
                        </div>
                    </div>
                    
                    <div v-if="option && option.name" class="form-line gift-registration-option-summary">
                        <div class="option-summary-left">
                            <img v-if="option.image_url" class="option-summary-image" :class="item.type=='voucher'?'voucher':''" :src="option.image_url">
                        </div>
                        <div class="option-summary-right">
                            <h3>{{ option.name }}</h3>
                            <div v-if="option.price" class="pricing large">Gift value: <b>{{ option.price | toCurrency }}</b></div>                        
                            <div v-if="item.type=='voucher'" class="pricing">
                                <div v-if="voucherDenominations.length">This brand requires choosing a specific voucher value.</div>
                                <div v-else>
                                    <div>Minimum value: <b>{{ voucherLimits.lower | toCurrency }}</b></div>
                                    <div>Maximum value: <b>{{ voucherLimits.upper | toCurrency }}</b></div>
                                    <div>Minor unit: <b>{{ voucherLimits.minor_unit | toCurrency }}</b></div>
                                </div>
                            </div>
                        </div>
                    </div>   
                
                    <div class="form-line">
                        <div class="form-field" style="width: 50%">
                            <label>First Name</label>
                            <input v-model="item.first_name">
                        </div>
                        <div class="form-field" style="width: 50%">
                            <label>Last Name</label>
                            <input v-model="item.last_name">
                        </div>
                        
                        <div class="form-field" v-if="team.corporation_id!=5">
                            <label>Email</label>
                            <input v-model="item.email">
                            
                            <div class="field-note">Please enter either invitee's <i>name</i> or <i>email address</i> to identify the recipient.<!-- An <b>unique one-time url</b> will be generated, which can be used by your invitee to claim their gift.--></div>
                        </div>
                    </div>
                    
                    <div class="form-line">
                      <div class="form-field form-field-checkbox" >
                          <label>Additional Verification</label>
                          <div class="radio-option">
                            <input v-model="item.password_type" type="radio" value="none">
                            <span class="radio-label">No verification</span>
                          </div>

                          <div class="radio-option" v-if="team.corporation_id!=5">
                            <input v-model="item.password_type" type="radio" value="email" :disabled="item.email.length==0">
                            <span class="radio-label">Require to use same email address as above</span>
                          </div>
                          
                          <div class="radio-option" v-if="team.corporation_id==5">
                            <input v-model="item.password_type" type="radio" value="name" :disabled="!(item.first_name.length!=0 && item.last_name.length!=0)" >
                            <span class="radio-label">Require to use the same first and last name as above</span>
                          </div>
                          
                          <div class="field-note" v-if="team.corporation_id!=5" style="margin-top: -2px">You can choose if you want the recipient to type their email as a password to claim the gift as an extra security measure.</div>
                      </div>
                    </div>
                    
                    <div class="form-line" v-if="team.corporation_id != 5">
                        <div class="form-field form-field-checkbox" >
                            <label>Send Invitation Email</label>
                            <div class="radio-option">
                              <input v-model="item.send_email" type="checkbox" value="true">
                              <span class="radio-label">Yes, please send an invitation email to the invitee.</span>
                            </div>
                        </div>
                        <div class="form-field form-field-checkbox" v-if="item.send_email==true || item.send_email=='true'" >
                            <label>Custom Email Text</label>
                            <div class="checkbox-option">
                              <input v-model="item.custom_email_message" type="checkbox">
                              <span class="checkbox-label">Add custom text to info email.</span>
                            </div>  
                            <textarea v-if="item.send_email && item.custom_email_message" v-model="item.invitation_message" placeholder="Write your custom email info message here." rows="6" maxlength="1015"></textarea>
                        </div>        
                    </div>        
                        
                    <!--                
                    <div class="modal-errors">
                        <p v-for="e in errors" class="form-field error-text">{{ e[0] }}</p>
                    </div>
                    -->
                </div>
                
                <!-- Notecard -->
                <div class="form-step step-notecard" v-if="step === 'notecard'"> 
                    <h4><b>Step 2:</b> Attach a Greeting Card</h4> 
                    <field-notecard :item="item" :campaign="campaign"></field-notecard>
                </div>
                
                <div class="form-step step-start" v-else-if="step === 'summary'">
                    <h4><b>Last Step:</b> Summary & Payment</h4>
                    <div class="form-line" >
                        <div class="form-field">
                            <label>Price Breakdown</label>
                            <payment-summary-table :prices="prices" :prices-ex-vat="pricesExVat" :item="item" :platform="platform" :type="item.type"></payment-summary-table>
                            <div class="small-note" v-if="platform=='gifting'"><span>NOTE:</span> <b>You will be charged only after your recipient claims the gift</b>. 
                                <i v-if="campaign.reward_type=='physical'">The shipping price will be calulated then depending on the gift option and recipient country.</i>
                                <i v-if="campaign.reward_type=='voucher'">The voucher value charge will be calculated then depending on recipient's choice.</i>
                            </div>
                            <div class="small-note" v-if="platform=='marketplace'"><span>NOTE:</span> <b>You will be charged the full price above now. </b>
                                <i>If your recipient doesn't claim or rejects the gift, you can request a refund from us.</i>
                            </div>
                        </div>
                    </div>
                    <field-payment :item="item" type="link" :prices="prices" :platform="platform"></field-payment>
                </div>
            </form>
            
            <div class="form-actions">
                <div class="ws-button ws-button-secondary" data-action="cancel" @click="modals.giftInviteModal = false">Cancel</div>
                <div v-if="step!=='start'" class="ws-button" data-action="continue" @click="previousStep">Go Back</div>
                <div v-if="step!=='summary'" class="ws-button ws-button-main" data-action="continue" @click="nextStep">Continue</div>
                <div v-if="step=='summary' && userCanCheckout" class="ws-button ws-button-main" data-action="submit" @click="generateUniqueLink">Create Invitation</div>
            </div>
        </div>

        <!-- Payment Processing -->
        <div v-else-if="screen === 'payment'">
            <div class="ws-form-processing"><div class="value-loader"></div><p>We are processing your payment. <br>Please give us a moment...</p></div>
        </div>
        
        <!-- Order Prgcessing -->
        <div v-else-if="screen === 'processing'">
            <div class="ws-form-processing"><div class="value-loader"></div><p>We are processing your order. <br>Please give us a moment...</p></div>
        </div>
        
        <!-- Loading -->
        <div v-else-if="screen === 'loading'">
            <div class="ws-form-processing">
                <div class="value-loader"></div>
                <p>
                    <span v-if="this.details.registration_id">We're retrieving your gift registration.</span>
                    <span v-else>We're verifying your gift option availability.</span>
                    <br>Please give us a moment...
                </p>
            </div>
        </div>
        
        <!-- Link Info Window -->
        <div v-else-if="screen === 'details'">
            <h3>Campaign Invitation Created</h3>
            <div class="large-form">
                  <div class="form-line">
                      <h4 v-if="details.is_multi && details.batch_label" style="margin-top: 0">Multi invite batch: <b>{{ details.batch_label }}</b></h4>
                      <p v-if="details.email_sent"><b>The campaign invitation email has been sent</b> to your recipient.<br /><br />We have also generated an unique gift registration link - you can copy it below and re-share it with your invitee if you want.</p>
                      <p v-else><b>The campaign invitation has been created</b> and an unique gift registration link has been generated. You can copy it below and share it to your invitee.</p>
                      <p><a :href="details.invite_link" target="_blank">{{ details.invite_link }}</a></p>
                      <div style="margin: 20px auto"><span class="ws-button ws-button-main" @click="copyToClipboard(details.invite_link)">COPY GIFT REGISTRATION LINK</span></div>
                      <p v-if="['name','email'].includes(details.password_type) && details.password_value">To claim the gift invitee needs to register using this {{ details.password_type }}: <br><b>{{ details.password_value }}</b></p>
                  </div>
            </div>
            <div class="form-actions">
                <span class="ws-button ws-button-secondary" data-action="cancel" @click="modals.giftInviteModal = false">CLOSE</span>
            </div>
        </div>
    </modal>
</template>

<script>
import Modal from "@/components/modals/Modal";
import FieldNotecard from "@/components/FieldNotecard";
import PaymentSummaryTable from "@/components/PaymentSummaryTable";
import FieldPayment from "@/components/FieldPayment";

export default {
    name: "GiftInviteModal",
    components: {Modal,FieldNotecard,PaymentSummaryTable,FieldPayment},
    props: {
        campaignId: Number,
        productId: Number,
        registrationLinkDetails: Object,
        platform: {type: String, default: 'gifting'},
        voucherBrand: String,
    },
    data() {
        return {
            item: {email: '', first_name: '', last_name: '', password_type: 'none', notecard_text: '', notecard_type: 'none', product_id: 0, type: 'physical', payment_method: 'team-balance', payment_method_id: null, payment_id: null, voucher_value: 0, send_email: false, custom_email_message: false, invitation_message: ''},
            details: {registration_id: null, invite_link: null},
            screen: 'loading',
            step: 'start',
            physicalSteps: ['start','notecard','summary'],
            digitalSteps: ['start','summary'],
            prices: {prepaid: 0, gift: 0, notecard: 0, admin: 0, shipping: 0, voucher: 0, total: 0},
            pricesExVat: {prepaid: 0, gift: 0, notecard: 0, admin: 0, shipping: 0, voucher: 0, total: 0},
            option: null,
            voucherLimits: {lower: 2, upper: 500, minor_unit: 0.01},
            voucherDenominations: [],
        }
    },
    methods: {
        nextStep() {
            let steps = this.physicalSteps;
            if (this.item.type=='voucher') steps = this.digitalSteps;
            for (let i = 0; i!=steps.length; i++) if (steps[i]==this.step) {
                //if (this.verifyStep(this.step)) 
                this.goToStep(steps[i+1]);
                break;
            }
        },
        previousStep() {
            let steps = this.physicalSteps;
            if (this.item.type=='voucher') steps = this.digitalSteps;
            for (let i = 0; i!=steps.length; i++) if (steps[i]==this.step) {
                this.goToStep(steps[i-1]);
                break;
            }
        },
        goToStep(step) {
            this.step = step;
        },
        async generateUniqueLink() {   
            if (!this.demoCheck()) return;
                    
            if (this.prices.total!==0) {
                this.screen = 'payment'; 
                try {
                    if (this.item.payment_method == 'stripe') {
                        let descDetail = '';
                        if (this.platform=='marketplace' && this.item.product_id) descDetail = 'Product ID: #'+this.item.product_id;
                        else if (this.platform=='marketplace' && this.item.voucher_brand) descDetail = 'Voucher Brand: '+this.item.voucher_brand;
                        else if (this.item.option_id) descDetail = 'Option ID: #'+this.item.option_id;
                        
                        await this.dispatchWaitAndNotify('postStripePaymentIntent', {
                            'payment_method_id': this.item.payment_method_id,
                            'amount': this.prices.total,
                            'description': 'Bookblock HUB Pro '+this.platform.toUpperCase()+' Invitation ('+descDetail+')',
                            'suffix': (this.platfom=='marketplace')?'market':'gifting',
                        }, false, true);
                        this.item.payment_id = this.paymentIntentResult.payment_intent_id;
                    } else {
                        await this.dispatchWaitAndNotify('checkTeamBalance', this.prices.total, false, true);
                    }
                } catch (e) {
                    this.screen = 'form';
                    return;
                }
            }
            
            if (this.item.email === '') delete this.item.email;
            
            this.screen = 'processing';
            try {
                if (this.platform =='gifting') this.details = await this.dispatchWaitAndNotify('giftCampaignGenerateLink', {campaignId: this.campaignId, payload: this.item} );
                else if (this.platform =='marketplace') this.details = await this.dispatchWaitAndNotify('marketplaceGenerateLink', {payload: this.item} );
                this.screen = 'details';
                this.$emit('generated');
            } catch (e) {
                this.screen = 'form';
            }      
        },
        copyToClipboard(text) {
            const el = document.createElement('textarea');
            el.value = text;
            el.setAttribute('readonly', '');
            el.style.position = 'absolute';
            el.style.left = '-9999px';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            this.notifyStatus(200, 'Link Copied', 'The link has been copied to your clipboard.');
    	},
        updatePrice(type,price) {
            if (typeof price.iv !== 'undefined') this.prices[type] = parseFloat(price.iv);
            if (typeof price.ev !== 'undefined') this.pricesExVat[type] = parseFloat(price.ev);

            if (this.item.type=='physical') {
                this.prices.total = this.prices.gift + this.prices.notecard + this.prices.admin + this.prices.shipping;
                this.pricesExVat.total = this.pricesExVat.gift + this.pricesExVat.notecard + this.pricesExVat.admin + this.pricesExVat.shipping;
            }
            if (this.item.type=='voucher') {
                this.prices.total = this.prices.voucher + this.prices.admin;
                this.pricesExVat.total = this.pricesExVat.voucher + this.pricesExVat.admin;
            }
        },
    },
    async mounted() {
        if (!this.proCheck('Sending campaign invites')) {
            this.modals.giftInviteModal = false;
            return;
        }
        
        this.item.platform = this.platform;

        if (this.registrationLinkDetails && Object.keys(this.registrationLinkDetails).length) {
          this.details = this.registrationLinkDetails;
          this.screen = 'details';
          return;
        }

        if (this.productId) {
          this.option = await this.dispatchWaitAndNotify('fetchMarketplaceProduct', {productId: this.productId}, false, true);
          this.item.type = this.option.type;
          this.item.product_id = this.productId;
        } else if (this.voucherBrand) {
          this.option = await this.dispatchWaitAndNotify('fetchMarketplaceDigitalProduct', this.voucherBrand, false, true);
          this.item.type = this.option.type;
          this.item.voucher_brand = this.option.slug;
          this.item.voucher_value = 10;
          this.updatePrice('admin',{ev: 1, iv: 1.2});
          
          if (this.option.face_value_limits) {
              this.voucherLimits = this.option.face_value_limits;
              if (this.option.face_value_limits.lower > this.item.voucher_value) this.item.voucher_value = this.option.face_value_limits.lower;
          } else if (this.option.denominations) {
              this.voucherDenominations = this.option.denominations;
              this.item.voucher_value = this.option.denominations[0];
          }
        } else if (this.campaign && this.campaign.reward_type) {
          this.item.type = this.campaign.reward_type;
        }
        this.screen = 'form';
    },
    computed: {
        team() {
			return this.$store.state.team.detail;
		},
        campaign() {
            return this.$store.state.giftBoxCampaign.detail;
        },
        modals() {
            return this.$store.state.modals;
        },
        user() {
            return this.$store.state.currentUser;
        },
        userCanCheckout() {
            return this.user.permissions && 
                (
                    (this.user.permissions.includes('use-balance') && this.item.payment_method=='team-balance') ||
                    (this.user.permissions.includes('use-cards') && this.item.payment_method_id && this.platform=='marketplace')
                )
        },
        paymentIntentResult() {
            return this.$store.state.transaction.paymentIntentResult;
        }
    },
    watch: {
        'option.price': {
            handler (value) {
                if (this.platform == 'gifting') {
                    this.updatePrice('prepaid',{iv: value});
                    this.updatePrice('gift',{iv: 0});
                } else if (this.platform == 'marketplace') {
                    this.updatePrice('prepaid',{iv: 0});
                    this.updatePrice('gift',{iv: value});
                }
            },
        },
        'option.price_ex_vat': {
            handler (value) {
                if (this.platform == 'gifting') {
                    this.updatePrice('prepaid',{ev: value});
                    this.updatePrice('gift',{ev: 0});
                } else if (this.platform == 'marketplace') {
                    this.updatePrice('prepaid',{ev: 0});
                    this.updatePrice('gift',{ev: value});
                }
            },
        },
        'option.shipping': {
            handler (value) {
                this.updatePrice('shipping',{iv: value});
            },
        },
        'option.shipping_ex_vat': {
            handler (value) {
                this.updatePrice('shipping',{ev: value});
            },
        },
		'item.voucher_value': {
			handler (value) {
				this.updatePrice('voucher',{ev: value, iv: value});
			},
		},
        'item.notecard_type': {
			handler (value) {
                if (this.item.notecard_type=='default' || (this.item.notecard_type=='custom' && this.item.notecard_text!='')) 
                    this.updatePrice('notecard',{ev: this.$store.state.notecard_price_exc_vat, iv: this.$store.state.notecard_price});
                else this.updatePrice('notecard',{ev: 0, iv: 0});
			},
		},
        'item.notecard_text': {
			handler (value) {
                if (this.item.notecard_type=='default' || (this.item.notecard_type=='custom' && this.item.notecard_text!='')) 
                    this.updatePrice('notecard',{ev: this.$store.state.notecard_price_exc_vat, iv: this.$store.state.notecard_price});
                else this.updatePrice('notecard',{ev: 0, iv: 0});
			},
		}
	}
}
</script>

<style scoped>

</style>